import { IGroupByListColumn } from "models/groupBy";

/**
 * Extracts unique field groups (subgroups) from a list of field IDs.
 * Used when deleting fields to know which field group data queries to invalidate.
 *
 * @param allColumns - Array of all available columns
 * @param fieldIds - Array of field IDs to extract groups from
 * @returns Array of unique subgroup names, or undefined if none found
 */
export function getUniqueFieldGroups(
  allColumns: IGroupByListColumn[] | null,
  fieldIds: string[]
): string[] | undefined {
  if (!allColumns || !fieldIds.length) {
    return undefined;
  }

  const subgroups = new Set<string>();

  allColumns.forEach((col) => {
    if (fieldIds.includes(col.id) && col.subgroup) {
      subgroups.add(col.subgroup);
    }
  });

  return subgroups.size > 0 ? Array.from(subgroups) : undefined;
}
